import TitleSecondary from "../Title/TitleSecondary";
import stylesad2 from "../../pages/Admin/Admin2.module.css";
import DateService from "../../services/DateService";
import BtnSwitch from "../Button/BtnSwitch";
import {commentAdd, commentCheck, toggleComments} from "../../services/CommentService";
import stylesSwitch from "../Button/BtnSwitch.module.css";
import {Link} from "react-router-dom";
import Routing from "../../services/routing";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import React, {Fragment, useEffect, useState} from "react";
import {useModal} from "../../contexts/ModalContext";
import Comment from "./Comment";
import AddComment from "./AddComment";

function RenderComments ({ urlGetComments, urlAddComment, data }) {
    const [comments, setComments] = useState(null);
    const [showAddForm, setShowAddForm] = useState(false);
    const [newComment, setNewComment] = useState({ title: '', text: '', dateNotif: '', check: '' });
    const [submitting, setSubmitting] = useState(false);
    const {showModal, hideModal} = useModal();

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    useEffect(() => {
        setTimeout(async () => {
            await toggleComments(urlGetComments, setComments, handleError);
        }, 800);
    }, [data]);

    return <div style={{display: "flex", flexDirection: "column", gap: "16px", minWidth: "400px"}}>
        <TitleSecondary text={"Commentaires"} style={{ margin: 0}}/>
        {comments ?
            comments.length > 0 ?
                comments.map(comment => (
                    <Comment key={comment.id} comment={comment} urlGetComments={urlGetComments} setComments={setComments} />
                ))
                :
                <div className={stylesad2.blok}>
                    <p>Aucun commentaire</p>
                </div>
            : <div className={stylesad2.blok}>
                <p>Chargement...</p>
            </div>
        }

        <AddComment urlAddComment={urlAddComment} urlGetComments={urlGetComments} setComments={setComments}  />
    </div>;
}

export default RenderComments;